import { notifications } from '@mantine/notifications';
import { useAddProposal } from '@/models/offers';
import { TCommercialProposal } from '@/models/commercial-proposal';
import ProposalSelector from '@/components/proposal-selector/ProposalSelector';

interface Props {
  offerId: number;
  opened: boolean;
  onClose: () => void;
  /** True when the offer already has a schedule this change would discard. */
  dropsSplitPlan?: boolean;
}

export default function AddProposalModal({
  offerId,
  opened,
  onClose,
  dropsSplitPlan = false,
}: Props) {
  const addProposal = useAddProposal();

  const handleSelect = async (proposal: TCommercialProposal) => {
    try {
      await addProposal.mutateAsync({
        offerId,
        cpId: proposal.id,
        invalidateSplitPlan: dropsSplitPlan,
      });
      onClose();
    } catch (e) {
      notifications.show({
        color: 'red',
        title: 'Error',
        message: `Failed to add proposal: ${e}`,
      });
    }
  };

  return (
    <ProposalSelector
      opened={opened}
      onClose={onClose}
      onSelect={handleSelect}
    />
  );
}
